import React, { useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { createAction } from '../../utils';
import {
  SectionTopTitle,
  FieldControl,
} from '../base/CommonComponent';
import AddNewAdminGroupPrompt from './AddNewAdminGroupPrompt';
import { PermissionCodes } from 'config/PermissionCodes';
import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import { ADMIN_PERMISSION_TYPE } from 'config/CustomEnums';

const PERMISSION_TYPE = {
  GROUP: 'GROUP',
  PERMISSION: 'PERMISSION',
};

function PermissionFieldControl({
  name,
  type,
  datas,
  selected,
  setValue,
  button,
}) {
  const isGroup = type === PERMISSION_TYPE.GROUP;
  const title = isGroup ? 'Permission Groups' : 'Users permission';
  const namespace = isGroup ? 'adminGroup' : 'admin';
  const tips = isGroup
    ? 'Select permission groups which this user belongs to. The user will get all permissions granted from the selected permission groups.'
    : 'Assign permission(s) to this user.';
  return (
    <FieldControl
      name={name}
      render={() => (
        <>
          <BaseMultipleSelectorV2
            title={title}
            namespace={namespace}
            groupKey={isGroup ? null : "groupKey"}
            data={{
              sourceData: datas,
              targetData: selected,
              targetChange: setValue,
            }}
            requires={PermissionCodes.addAdministratorGroup}
            addButton={button}
            tips={tips}
          />
        </>
      )}
    />
  );
}

function PermissionSections({
    permissionGroups,
    allPermissions,
    adminType
}) {
  const { watch, setValue } = useFormContext();
  const permissionGroupFieldName = 'groups';
  const permissionFieldName = 'permissions';
  const watchPermissionGroups = watch(permissionGroupFieldName) || [];
  const watchPermissions = watch(permissionFieldName) || [];
  const dispatch = useDispatch();
  const [showAddAdminGroupPrompt, setShowAddAdminGroupPrompt] = useState(false);
  useEffect(() => {
    dispatch(createAction('admin/getAllPermissions')({
      isMerchant: adminType === ADMIN_PERMISSION_TYPE.MERCHANT_ADMIN_PERMISSON
    }))
    dispatch(createAction('adminGroup/getAllList')({
      adminType
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPermissionGroup = ({
    type,
    datas,
    selected,
    setValue,
    button,
    name,
  }) => {
    return (
      <PermissionFieldControl
        type={type}
        datas={datas}
        selected={selected}
        setValue={setValue}
        button={button}
        name={name}
      />
    );
  };

  const permissionGroupSection = getPermissionGroup({
    type: PERMISSION_TYPE.GROUP,
    datas: permissionGroups,
    selected: watchPermissionGroups,
    setValue: (value) => {
      setValue(permissionGroupFieldName, value, { shouldDirty: true });
    },
    button: {
      title: 'Add Permission Group',
      action: () => setShowAddAdminGroupPrompt(true),
      customClass: 'btn-back-button-common add-remove-botton-style',
    },
    name: permissionGroupFieldName,
  });

  const permissionSection = getPermissionGroup({
    type: PERMISSION_TYPE.PERMISSION,
    datas: allPermissions,
    selected: watchPermissions,
    setValue: (value) => {
      setValue(permissionFieldName, value, { shouldDirty: true });
    },
    name: permissionFieldName,
  });

  return (
    <>
      <SectionTopTitle title="Permission(optional)" />
      {permissionGroupSection}
      {permissionSection}
      <AddNewAdminGroupPrompt
        adminType={adminType}
        show={showAddAdminGroupPrompt}
        onClose={() => setShowAddAdminGroupPrompt(false)}
        onConfirm={(item) => {
          dispatch(
            createAction('adminGroup/getAllList')({ adminType }),
          );
          setValue(
            permissionGroupFieldName,
            [
              ...watchPermissionGroups,
              item,
            ],
            {
              shouldDirty: true,
            },
          );
          setShowAddAdminGroupPrompt(false);
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
    permissionGroups: state.adminGroup.notPagedAllList || [],
    allPermissions: state.admin.allPermissionList || [],
})

export default connect(mapPropsToState)(PermissionSections);
